import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/fonts.css";
import NovemberLogo from "./assets/nowemberlogo.png";
import { Provider } from "./Components/ui/provider";

function App() {
  return (
    <div
      style={{
        backgroundColor: "darkgrey",
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={NovemberLogo} style={{ height: 150 }} />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider>
      <App />
    </Provider>
  </React.StrictMode>
);
